import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

import './emptyStateLQI.scss';

type Props = {
  onClick: () => void;
};

function EmptyState({ onClick }: Props) {
  const { formatMessage } = useIntl();
  return (
    <div className="emptyStateLQI">
      <ButtonUI
        icon="fa-regular fa-plus fa-lg"
        iconPosition="left"
        onClick={onClick}
        shape="link"
        size="small"
        text={formatMessage({
          defaultMessage: 'Set Location Quality Indexes',
          id: 'targeting.lqi.emptyState'
        })}
        type="secondary"
      />
    </div>
  );
}

export default EmptyState;
